import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';

const BASE = '/admin/room-wanted-ads';

export const roomWantedApi = {
  list: async (params: any) => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getById: async (id: any) => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },

  update: async (id: any, data: any) => {
    const res = await apiClient.patch(`${BASE}/${id}`, data);
    return res.data?.data;
  },

  delete: async (id: any) => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },

  listImages: async (adId: number | string) => {
    const res = await apiClient.get(`${BASE}/${adId}/images`);
    return (res.data?.data ?? []) as RoomWantedImageDTO[];
  },

  uploadImages: async (
    adId: number | string,
    files: File[],
    onProgress?: (pct: number) => void,
  ): Promise<RoomWantedImageDTO[]> => {
    const fd = new FormData();
    files.forEach((f) => fd.append('images', f, f.name));
    const res = await apiClient.post(`${BASE}/${adId}/images`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (!onProgress || !e.total) return;
        onProgress(Math.round((e.loaded * 100) / e.total));
      },
    });
    return (res.data?.data ?? []) as RoomWantedImageDTO[];
  },

  uploadVideos: async (
    adId: number | string,
    files: File[],
    onProgress?: (pct: number) => void,
  ): Promise<RoomWantedImageDTO[]> => {
    const fd = new FormData();
    files.forEach((f) => fd.append('videos', f, f.name));
    const res = await apiClient.post(`${BASE}/${adId}/images/videos`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (!onProgress || !e.total) return;
        onProgress(Math.round((e.loaded * 100) / e.total));
      },
    });
    return (res.data?.data ?? []) as RoomWantedImageDTO[];
  },

  deleteImage: async (adId: number | string, imageId: number) => {
    await apiClient.delete(`${BASE}/${adId}/images/${imageId}`);
  },

  setPrimaryImage: async (adId: number | string, imageId: number): Promise<RoomWantedImageDTO[]> => {
    const res = await apiClient.post(`${BASE}/${adId}/images/${imageId}/primary`);
    return (res.data?.data ?? []) as RoomWantedImageDTO[];
  },
};

export type RoomWantedImageDTO = {
  id: number;
  imageUrl: string;
  position: number;
  isPrimary: boolean;
  mediaType?: 'IMAGE' | 'VIDEO';
};
